<tec-modal
	[isVisible]="true"
	type="scrollable"
	[title]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.MODAL_TITLE' | translate"
	[tagImage]="{ icon: 'icon-text', status: 'default' }"
	[buttonPrimaryLabel]="'BUTTON.SAVE' | translate"
	[buttonSecondaryLabel]="'BUTTON.CANCEL' | translate"
	(closeEvent)="closeModal($event)"
>
	<ng-container body [formGroup]="form">
		<div class="finish-result-messages">
			<tec-alert
				type="message"
				status="warning"
				icon="icon-info"
				[msg]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.AUDIO_WARNING' | translate"
				hiddenCloseButton
			/>

			<tec-tabs [tabs]="tabs" type="pills" (tabSelected)="onLocaleTabSelected($event)">
				<div class="finish-result-messages__sections">
					<tec-tile
						[title]="'WORKFLOWS.FORM.OPERATIONS.LOADING_TEXT' | translate"
						[tooltip]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.LOADING_TOOLTIP' | translate"
					>
						<ng-container actions>
							<tec-link
								[label]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.RESET' | translate"
								(click)="resetSection('loading')"
							/>
						</ng-container>
						<tec-textarea
							[formControl]="localeControl('loading_text')"
							[placeholder]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.LOADING_PLACEHOLDER' | translate"
							[hasError]="fieldHasError('loading_text')"
						/>
					</tec-tile>

					<tec-tile
						[title]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.OK_SECTION' | translate"
						[tooltip]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.OK_TOOLTIP' | translate"
					>
						<ng-container actions>
							<tec-link
								[label]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.RESET' | translate"
								(click)="resetSection('ok')"
							/>
						</ng-container>
						<div class="grid grid-i2">
							<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.TITLE_LABEL' | translate">
								<tec-textarea
									[formControl]="localeControl('ok_title')"
									[placeholder]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.TITLE_PLACEHOLDER' | translate"
									[hasError]="fieldHasError('ok_title')"
								/>
							</tec-form-group>
							<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.DESCRIPTION_LABEL' | translate">
								<tec-textarea
									[formControl]="localeControl('ok_description')"
									[placeholder]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.DESCRIPTION_PLACEHOLDER' | translate"
								/>
							</tec-form-group>
						</div>
					</tec-tile>

					<tec-tile
						[title]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.KO_SECTION' | translate"
						[tooltip]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.KO_TOOLTIP' | translate"
					>
						<ng-container actions>
							<tec-link
								[label]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.RESET' | translate"
								(click)="resetSection('ko')"
							/>
						</ng-container>
						<div class="grid grid-i2">
							<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.TITLE_LABEL' | translate">
								<tec-textarea
									[formControl]="localeControl('ko_title')"
									[placeholder]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.TITLE_PLACEHOLDER' | translate"
									[hasError]="fieldHasError('ko_title')"
								/>
							</tec-form-group>
							<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.DESCRIPTION_LABEL' | translate">
								<tec-textarea
									[formControl]="localeControl('ko_description')"
									[placeholder]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.DESCRIPTION_PLACEHOLDER' | translate"
								/>
							</tec-form-group>
						</div>
					</tec-tile>

					<tec-tile
						[title]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.CANCELLED_SECTION' | translate"
						[tooltip]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.CANCELLED_TOOLTIP' | translate"
					>
						<ng-container actions>
							<tec-link
								[label]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.RESET' | translate"
								(click)="resetSection('cancelled')"
							/>
						</ng-container>
						<div class="grid grid-i2">
							<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.TITLE_LABEL' | translate">
								<tec-textarea
									[formControl]="localeControl('cancelled_title')"
									[placeholder]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.TITLE_PLACEHOLDER' | translate"
									[hasError]="fieldHasError('cancelled_title')"
								/>
							</tec-form-group>
							<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.DESCRIPTION_LABEL' | translate">
								<tec-textarea
									[formControl]="localeControl('cancelled_description')"
									[placeholder]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.DESCRIPTION_PLACEHOLDER' | translate"
								/>
							</tec-form-group>
						</div>
					</tec-tile>

					<tec-tile
						[title]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.PENDING_SECTION' | translate"
						[tooltip]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.PENDING_TOOLTIP' | translate"
					>
						<ng-container actions>
							<tec-link
								[label]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.RESET' | translate"
								(click)="resetSection('pending')"
							/>
						</ng-container>
						<div class="grid grid-i2">
							<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.TITLE_LABEL' | translate">
								<tec-textarea
									[formControl]="localeControl('pending_title')"
									[placeholder]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.TITLE_PLACEHOLDER' | translate"
									[hasError]="fieldHasError('pending_title')"
								/>
							</tec-form-group>
							<tec-form-group [label]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.DESCRIPTION_LABEL' | translate">
								<tec-textarea
									[formControl]="localeControl('pending_description')"
									[placeholder]="'WORKFLOWS.FORM.OPERATIONS.FINISH_RESULT_MESSAGES.DESCRIPTION_PLACEHOLDER' | translate"
								/>
							</tec-form-group>
						</div>
					</tec-tile>
				</div>
			</tec-tabs>
		</div>
	</ng-container>
</tec-modal>
